import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { useTranslation as o } from "../../../hooks/useTranslation/index.js";
import { LoadingIcon as p } from "../../../components/Loading/style.js";
import { Container as m, LoadingContainer as d } from "./style.js";
function b({
  children: t,
  loading: a,
  onFileChange: i
}) {
  const { t: e } = o("common");
  return /* @__PURE__ */ n(
    m,
    {
      "aria-label": e("avatar-edit-aria-label"),
      "aria-busy": a,
      "aria-disabled": a,
      disabled: a,
      htmlFor: "edit-avatar-input",
      role: "button",
      children: [
        a ? /* @__PURE__ */ r(d, { children: /* @__PURE__ */ r(p, {}) }) : t,
        /* @__PURE__ */ r(
          "input",
          {
            type: "file",
            accept: "image/jpg, image/jpeg, image/png",
            onChange: i,
            id: "edit-avatar-input"
          }
        )
      ]
    }
  );
}
export {
  b as EditAvatarWrapper
};
